import { render } from "./SlideShowPage.vue?vue&type=template&id=5eed466d&scoped=true"
import script from "./SlideShowPage.vue?vue&type=script&lang=js"
export * from "./SlideShowPage.vue?vue&type=script&lang=js"

import "./SlideShowPage.vue?vue&type=style&index=0&id=5eed466d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eed466d"]])

export default __exports__